
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.067 31.725h-.007a15.982 15.982 0 01-7.614-1.93L0 32l2.26-8.217a15.777 15.777 0 01-2.127-7.927C.137 7.113 7.284 0 16.066 0c4.262.002 8.263 1.653 11.271 4.65s4.664 6.981 4.662 11.218c-.004 8.741-7.148 15.853-15.933 15.857zm-7.229-4.801l.484.286a13.27 13.27 0 006.74 1.837h.005c7.299 0 13.24-5.912 13.243-13.18.001-3.522-1.375-6.833-3.875-9.324s-5.825-3.864-9.363-3.865c-7.305 0-13.246 5.912-13.248 13.178a13.099 13.099 0 002.025 7.014l.315.499-1.338 4.863 5.012-1.308zm15.256-7.285c-.099-.165-.365-.264-.763-.463s-2.355-1.157-2.72-1.289c-.365-.132-.63-.198-.896.198s-1.028 1.289-1.261 1.554c-.232.264-.465.298-.862.099s-1.681-.617-3.202-1.967c-1.184-1.051-1.982-2.348-2.215-2.745s-.025-.611.175-.809c.179-.178.398-.463.597-.694s.265-.397.398-.661c.133-.265.066-.496-.033-.694s-.896-2.149-1.227-2.942c-.323-.773-.651-.668-.896-.68-.232-.012-.498-.014-.763-.014s-.697.099-1.062.496c-.365.397-1.393 1.355-1.393 3.305s1.427 3.834 1.626 4.099c.199.265 2.807 4.266 6.801 5.983.95.408 1.691.652 2.27.835.954.302 1.822.259 2.508.157.765-.114 2.355-.958 2.687-1.884s.332-1.719.232-1.884z"}})])
          )
        }
      }
    